import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";

import { commentLikeQueries } from "@/react/lib/queries/commentLikes";
import type { Comment } from "@/react/types/Comment";
import type { ContentReactionType } from "@/react/types/ContentReaction";

interface UseCommentLikesParams {
  comment: Comment;
  reactionType?: ContentReactionType | null;
}

export const useCommentLikes = ({
  comment,
  reactionType,
}: UseCommentLikesParams) => {
  const { data, isInitialLoading, fetchNextPage, hasNextPage } =
    useInfiniteQuery(commentLikeQueries.list(comment.id, reactionType));

  const members = useMemo(
    () => data?.pages.flatMap(page => page.records) ?? [],
    [data],
  );
  const totalCount = data?.pages.at(-1)?.count;
  return {
    members,
    totalCount,
    isInitialLoading,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
  };
};
